import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faStar, faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, ChevronRight, Info, MapPin, Tickets, Calendar, Check, Dot } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from '../common/function';
import { changeAlramModal, changeGold, changeShoppingFriend, checkDuplicateLogins, checkShoppingLimit_KR } from '../../store';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Barcode from 'react-barcode';
import { ClipLoader, HashLoader } from "react-spinners";
import FallbackImage from '../common/FallbackImage';
import Coupons_Footer from '../common/coupons_footer';

function ShoppingDetail() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // URL 파라미터 예시 (couponId)를 받고 싶다면 useParams 사용
    const { shoppingId } = useParams();

    // navigate의 state로 전달된 쿠폰 정보
    const location = useLocation();
    const shoppingItem = location.state?.item;

    const JWT = useSelector((state) => state.JWT.value);
    const shoppingFriend = useSelector((state) => state.shoppingFriend.value);
    const gold = useSelector((state) => { return state.gold.value })
    const shoppingLimit_KR = useSelector((state) => state.shoppingLimit_KR);

    const [message, setMessage] = useState("");
    const [textBox, setTextBox] = useState(true);
    const [noticeBox, setNoticeBox] = useState(false);
    const [brands, setBrands] = useState([])
    const [totalList, setTotalList] = useState([])
    const [buyModal, setBuyModal] = useState(false)
    const [buyState, setBuyState] = useState(0)
    const [spinner, setSpinner] = useState(false)
    const [friendModal, setFriendModal] = useState(false)
    const [activeTab, setActiveTab] = useState(0);

    const scrollContainerRef = useRef(null);

    useEffect(() => {
        scrollContainerRef.current?.scrollTo({ top: 0, behavior: "smooth" });
        CategoryData();
        ListData()
        LimitData()
    }, [shoppingId]);

    const CategoryData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/exchange-events/coupon/user/coupon-categories',
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data?.data ?? [];
            setBrands(
                tmp?.brands.find(item => item.pc_category_name?.includes(shoppingItem.ci_brand_name))
            );
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const ListData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("page", "1");
            params.append("take", "6");
            params.append("coupon_type", "");
            params.append("brand", shoppingItem.ci_brand_name);
            params.append("sort_price", "");

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/exchange-events/coupon/user/coupon-products',
                params,
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data ?? [];
            setTotalList((tmp?.data?.filter(item => Number(item.ci_goods_no) !== Number(shoppingId)) ?? []));
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const LimitData = async () => {
        try {

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/exchange-events/coupon/user/daily-limit-status',
                {},
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data ?? [];
            console.log(tmp)
            dispatch(checkShoppingLimit_KR(tmp?.data ?? []))

        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const onSubmitBuy = async (goods_nm, state) => {
        if (gold >= shoppingItem.ci_point_price) {
            if (shoppingLimit_KR?.todayUsage?.remainingPoints >= shoppingItem.ci_point_price) {
                try {
                    const response = await axios.post(
                        process.env.REACT_APP_API + `/api/exchange-events/coupon/user/coupon-purchase`,
                        {
                            goods_code: goods_nm
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${JWT}`,
                            },
                        }
                    );
                    const tmp = response?.data;
                    console.log(tmp);

                    if (tmp.success) {
                        const trId = tmp?.data?.trId ?? "";

                        const intervalId = setInterval(async () => {
                            const isSuccess = await onSubmitCheckBuyState(trId, state);
                            if (isSuccess) clearInterval(intervalId); // 성공하면 인터벌 종료
                        }, 2000); // 2초 간격
                    } else {
                        setTimeout(() => {
                            setSpinner(false);
                            setMessage({ code: 1, msg: tmp?.error ?? "실패했습니다." });
                            dispatch(changeAlramModal());
                        }, 2000);
                    }
                } catch (error) {
                    if (error?.response?.status === 999) {
                        dispatch(checkDuplicateLogins(true));
                    } else {
                        console.error(error);
                    }
                }
            }
            else {
                setTimeout(() => {
                    setSpinner(false);
                    setMessage({ code: 1, msg: `오늘 구매량을 초과했습니다.\n(${changeNum(shoppingLimit_KR?.todayUsage?.pointUsed + shoppingItem?.ci_point_price ?? 0)}p / ${changeNum(shoppingLimit_KR?.settings?.dailyPointLimit ?? 0)}p)` });
                    dispatch(changeAlramModal());
                }, 2000);
            }
        } else {
            setTimeout(() => {
                setSpinner(false);
                setMessage({ code: 1, msg: "포인트가 부족합니다." });
                dispatch(changeAlramModal());
            }, 2000);
        }
    };

    const onSubmitGift = async (goods_nm, state, friend, message) => {
        if (gold >= shoppingItem.ci_point_price) {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_API + `/api/exchange-events/coupon/user/coupon-gift`,
                    {
                        goods_code: goods_nm,
                        friend_code: friend.friend_id,
                        gift_message: message,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${JWT}`,
                        },
                    }
                );
                const tmp = response?.data;

                if (tmp.success) {
                    const trId = tmp?.data?.trId ?? "";

                    const intervalId = setInterval(async () => {
                        const isSuccess = await onSubmitCheckBuyState(trId, state, friend.user_name, message);
                        if (isSuccess) clearInterval(intervalId); // 성공하면 인터벌 종료
                    }, 2000); // 2초 간격
                } else {
                    setTimeout(() => {
                        setSpinner(false);
                        setMessage({ code: 1, msg: tmp?.error ?? "실패했습니다." });
                        dispatch(changeAlramModal());
                    }, 2000);
                }
            } catch (error) {
                if (error?.response?.status === 999) {
                    dispatch(checkDuplicateLogins(true));
                } else {
                    console.error(error);
                }
            }
        } else {
            setTimeout(() => {
                setSpinner(false);
                setMessage({ code: 1, msg: "포인트가 부족합니다." });
                dispatch(changeAlramModal());
            }, 2000);
        }
    };

    const onSubmitCheckBuyState = async (trId, state, user_name, message = "") => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + `/api/exchange-events/coupon/user/purchase-status`,
                {
                    tr_id: trId
                },
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data;
            console.log(tmp);

            // 상태 확인
            if (tmp?.data?.status && tmp.data.status == "completed") {
                dispatch(changeGold(tmp?.data?.result?.data?.userGold ?? gold - Number(shoppingItem.ci_point_price)))
                navigate(`/shoppingBuy/${shoppingItem.ci_goods_no}`, {
                    state: { item: shoppingItem, state: state, message: message, friend_name: user_name },
                });
                return true; // 성공: 인터벌 종료
            }
            if (tmp?.data?.status && tmp?.data?.status == "failed") {
                setSpinner(false);
                setMessage({ code: 1, msg: tmp?.data?.result?.error ?? "실패했습니다." });
                dispatch(changeAlramModal());
                return true; // 실패도 인터벌 종료
            }
            if (!tmp?.success) {
                setSpinner(false);
                setMessage({ code: 1, msg: tmp?.error ?? "실패했습니다." });
                dispatch(changeAlramModal());
                return true; // 실패도 인터벌 종료
            }
        } catch (error) {
            console.error(error);
        }

        return false; // 아직 성공 아님: 반복 유지
    };

    // 뒤로가기
    const onBack = () => {
        navigate(-1);
    };

    // 예시: 지도로 이동하기
    const handleClickMap = () => {
        const brand = encodeURIComponent(shoppingItem.ci_brand_name);
        const url = `https://m.place.naver.com/restaurant/list?query=${brand}`;

        if (window.Telegram?.WebApp?.openLink) {
            // 텔레그램 미니앱
            window.Telegram.WebApp.openLink(url);
        } else {
            // 일반 브라우저
            window.open(url, '_blank');
        }
    };

    if (!shoppingItem) {
        return (
            <div style={{ padding: "20px" }}>
                쇼핑하기
            </div>
        );
    }

    const handleSelectCoupon = (coupon) => {
        navigate(`/shoppingDetail/${coupon.ci_goods_no}`, {
            state: { item: coupon },
        });
    };

    return (
        <div
            ref={scrollContainerRef}
            className="friend"
            style={{
                background: "#f5f5f5",
                padding: "0px",
                position: "relative",
                color: "#000"
            }}
        >
            {spinner && (
                <div
                    style={{
                        position: "fixed", // 👈 추가
                        top: 0,
                        left: 0,
                        width: "100dvw",
                        height: "100dvh",
                        background: "rgba(0,0,0,0.7)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <HashLoader
                        color="#ffbb3f"
                        size={70}
                        cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                        speedMultiplier={1}
                    />
                </div>

            )}

            {friendModal && (<ShoppingFriendModal setFriendModal={setFriendModal} shoppingItem={shoppingItem} setSpinner={setSpinner} onSubmitGift={onSubmitGift} />)}

            <div style={{ padding: '0px', paddingBottom: '150px', fontFamily: 'sans-serif' }}>
                <MessageModal message={message} />
                {/* 고정된 상단 헤더 */}
                <div
                    style={{
                        position: 'fixed',
                        top: "0px",
                        left: "0px",
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: "50px",
                        background: "#fff",
                        padding: "0 15px",
                        zIndex: "10",
                        borderBottom: "1px solid #dddddd"
                    }}
                >
                    {/* 뒤로가기 버튼 */}
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            left: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0 });
                        }}
                    >
                        <ChevronLeft style={{ width: '30px', height: '30px' }} onClick={() => onBack()} />
                    </div>

                    {/* 중앙 타이틀 */}
                    <div style={{ fontWeight: 'bold', color: "#000", fontSize: "18px" }}>
                        {t('shopping_15')}
                    </div>
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0 });
                            navigate('/shopping')
                        }}
                    >
                        <X style={{ width: '28px', height: '28px' }} />
                    </div>
                </div>
                <div style={{ position: "fixed", bottom: "0px", width: "100%", zIndex: "15", display: "flex" }}>
                    <div
                        style={{
                            margin: "0 auto",
                            background: "#ffbb3f",
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: "18px",
                            padding: "17px",
                            textAlign: "center",
                            cursor: "pointer",
                            height: "55px",
                            width: '100%',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => { setBuyState(1); setBuyModal(true) }}
                    >
                        {t('shopping_17')}
                    </div>
                    {/* {
                        shoppingLimit_KR?.limitStatus?.anyLimitReached
                            ?
                            <div
                                style={{
                                    margin: "0 auto",
                                    width: "100%",
                                    background: "gray",
                                    color: "#fff",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                    padding: "15px",
                                    textAlign: "center",
                                    height: "55px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    cursor: "pointer"
                                }}
                                onClick={() => { setBuyState(3); setBuyModal(true) }}
                            >
                                {t('shopping_32')} <FontAwesomeIcon icon={faCircleQuestion} style={{ fontSize: "18px", paddingTop: "2px" }} />
                            </div>
                            :
                            <>
                                <div
                                    style={{
                                        margin: "0 auto",
                                        background: "#000",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: "18px",
                                        padding: "17px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        height: "55px",
                                        width: '100%',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={() => { setBuyState(2); setBuyModal(true) }}
                                >
                                    {t('shopping_16')}
                                </div>
                                {
                                    shoppingFriend?.user_name
                                        ?
                                        ""
                                        :
                                        <div
                                            style={{
                                                margin: "0 auto",
                                                background: "#ffbb3f",
                                                color: "#000",
                                                fontWeight: "bold",
                                                fontSize: "18px",
                                                padding: "17px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                height: "55px",
                                                width: '100%',
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                            onClick={() => { setBuyState(1); setBuyModal(true) }}
                                        >
                                            {t('shopping_17')}
                                        </div>
                                }
                            </>
                    } */}
                </div>

                {buyModal && (<BuyModal setBuyModal={setBuyModal} shoppingItem={shoppingItem} setSpinner={setSpinner} setBuyState={setBuyState} buyState={buyState} setFriendModal={setFriendModal} onSubmitBuy={onSubmitBuy} onSubmitGift={onSubmitGift} setMessage={setMessage} />)}

                <div style={{ marginTop: "50px" }}>
                    <div style={{ background: "#fff" }}>
                        <FallbackImage
                            src={shoppingItem?.ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${shoppingItem.ci_custom_image_filename}` : shoppingItem.ci_goods_img_big}
                            style={{ width: "100%", aspectRatio: "1/1", borderBottom: "1px solid #f9f9f9", objectFit: "cover" }}
                        />
                    </div>

                    <div style={{ background: "#fff", padding: "10px 15px", textAlign: "left" }}>
                        <div style={{ fontSize: "20px", fontWeight: "500", marginBottom: "2px" }}>{shoppingItem.ci_goods_name}</div>
                        {/* <div style={{ display: "flex", alignItems: "center" }}>
                            {Array.from({ length: 4 }).map((_, i) => (
                                <FontAwesomeIcon
                                    key={i}
                                    icon={faStar}
                                    style={{ fontSize: "10px", color: "#f2df00", marginRight: "2px" }}
                                />
                            ))}
                            <div style={{ fontSize: "10px", color: "gray", marginLeft: "5px" }}>(0 건 구매)</div>
                        </div> */}

                        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", margin: "20px 0 10px" }}>
                            <div style={{ fontSize: "20px", fontWeight: "bold" }}>{changeNum(shoppingItem.ci_point_price)}p</div>
                        </div>
                    </div>

                    <div style={{ background: "#fff", margin: "1px 0px 8px", padding: "5px 15px", display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                        onClick={() => navigate('/brandsList', { state: { brands: brands, types: "" } })}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            {
                                brands?.pc_category_name && (
                                    <FallbackImage
                                        src={brands?.pc_category_custom_img ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${brands.pc_category_custom_img}` : brands?.pc_category_img}
                                        style={{ width: "40px", height: "40px", borderRadius: "50%", border: "1px solid #f9f9f9", objectFit: "cover" }}
                                    />
                                )
                            }
                            <div>{shoppingItem.ci_brand_name}</div>
                        </div>
                        <ChevronRight style={{ color: "gray" }} />
                    </div>
                    {
                        totalList?.length > 0
                            ?
                            <div style={{ background: "#fff", padding: "20px 15px 30px", marginBottom: "8px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div style={{ fontSize: "16px", fontWeight: "bold" }}>{t('shopping_19')}</div>
                                    <div style={{ fontSize: "14px", color: "gray", display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}
                                        onClick={() => navigate('/brandsList', { state: { brands: brands, types: "" } })}
                                    >{t('shopping_20')} <ChevronRight size={18} /></div>
                                </div>
                                <div style={{ display: "flex", gap: "10px", overflowX: "scroll", marginTop: "10px" }}>
                                    {totalList.map((item, idx) => (
                                        <div key={idx} style={{ textAlign: "left", cursor: "pointer", width: "150px" }} onClick={() => handleSelectCoupon(item)}>
                                            <FallbackImage
                                                src={item?.ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${item.ci_custom_image_filename}` : item.ci_goods_img_big}
                                                style={{ width: "150px", height: "150px", border: "1px solid #f9f9f9", borderRadius: "5px", objectFit: "cover" }}
                                            />
                                            <div className="table-overflow-2lines" style={{ fontSize: "14px", margin: "2px 0 5px", color: "#676767" }}>{item.ci_goods_name}</div>
                                            <div style={{ fontSize: "14px", fontWeight: "bold" }}>{changeNum(item.ci_point_price)}p</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            :
                            ""
                    }

                    <div style={{ background: "#fff", padding: "15px 0 0" }}>
                        <div
                            style={{
                                display: 'flex',
                                borderBottom: '1px solid #ddd',
                                color: "#000",
                                justifyContent: "space-around"
                            }}
                        >
                            <div style={{ width: '100%', display: "flex", alignItems: 'center', justifyContent: "center", cursor: 'pointer', }} onClick={() => setActiveTab(0)}>
                                <div
                                    style={{
                                        textAlign: 'center',
                                        padding: '0 0 15px',
                                        fontWeight: activeTab === 0 ? 'bold' : 'normal',
                                        borderBottom:
                                            activeTab === 0 ? '2px solid #000' : '2px solid transparent',
                                    }}
                                >
                                    {t('coupons_6')}
                                </div>
                            </div>

                            <div style={{ width: '100%', display: "flex", alignItems: 'center', justifyContent: "center", cursor: 'pointer', }} onClick={() => setActiveTab(1)}>
                                <div
                                    style={{
                                        textAlign: 'center',
                                        padding: '0 0 15px',
                                        fontWeight: activeTab === 1 ? 'bold' : 'normal',
                                        borderBottom:
                                            activeTab === 1 ? '2px solid #000' : '2px solid transparent',
                                    }}
                                >
                                    {t('coupons_7')}
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        activeTab === 0
                            ?
                            <>
                                <div
                                    style={{
                                        padding: "12px 15px",
                                        background: "#fff",
                                        marginBottom: "8px"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            padding: "5px 0px",
                                            color: "#000",
                                            textAlign: "left"
                                        }}
                                    >
                                        {t('coupons_14')}
                                    </div>
                                    <div style={{ width: "100%", padding: "5px 0", display: "flex", alignItems: 'flex-start', justifyContent: "space-between", marginBottom: "3px" }}>
                                        <div style={{ display: "flex", alignItems: 'center', gap: "10px" }}>
                                            <div style={{ color: '#5492ff', display: "flex", alignItems: 'center', justifyContent: "center" }}><Tickets size={20} /></div>
                                            <div style={{ fontSize: "14px", color: "#000" }}>{t('coupons_27')}</div>
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", padding: "5px 0", display: "flex", alignItems: 'flex-start', justifyContent: "space-between", marginBottom: "3px" }}>
                                        <div style={{ display: "flex", alignItems: 'center', gap: "10px" }}>
                                            <div style={{ color: '#5492ff', display: "flex", alignItems: 'center', justifyContent: "center" }}><Calendar size={20} /></div>
                                            <div style={{ fontSize: "14px", color: "#000" }}>{t('shopping_21_0')} <span style={{ fontSize: "12px", color: "gray" }}>{t('shopping_21_1')}</span></div>
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", padding: "5px 0", display: "flex", alignItems: 'flex-start', justifyContent: "space-between", position: "relative" }}>
                                        <div style={{ display: "flex", alignItems: 'center', gap: "10px" }}>
                                            <div style={{ color: '#5492ff', display: "flex", alignItems: 'center', justifyContent: "center" }}><MapPin size={20} /></div>
                                            <div style={{ fontSize: "14px", color: "#000", display: "flex", alignItems: "center" }}>
                                                {t('coupons_28')}
                                                {
                                                    shoppingItem?.ci_available_store && shoppingItem?.ci_unavailable_store &&
                                                    <Info size={14} style={{ color: "gray", marginLeft: "3px", cursor: "pointer" }} onClick={() => setNoticeBox(true)} />
                                                }
                                            </div>
                                        </div>
                                        <div
                                            style={{ background: "#f9f9f9", border: "1px solid #ebebeb", padding: "7px 10px", fontSize: "12px", display: "flex", alignItems: 'center', justifyContent: "center", color: "#757575", fontWeight: "500", cursor: "pointer" }}
                                            onClick={handleClickMap}>
                                            <div style={{ marginRight: "2px", color: "gray" }}><i className="fa-regular fa-map"></i></div>
                                            <div>{t('coupons_29')}</div>
                                        </div>
                                        {textBox && (
                                            <div style={{ position: "absolute", right: "0", bottom: "30px", color: "#ddd" }}>
                                                <img src='/newImg/textbox.png' style={{ width: "205px" }} />
                                                <X style={{ width: '22px', height: '22px', position: "absolute", right: "5px", top: '5px', color: "#9d9d9d", cursor: "pointer", zIndex: "1" }} onClick={() => setTextBox(false)} />
                                                <div style={{ position: "absolute", top: "45%", left: "50%", transform: 'translate(-50%, -55%)', fontSize: "13px", width: "100%" }}>
                                                    {t('coupons_30_0')}<br />
                                                    <span style={{ color: "#f3df35" }}>{t('coupons_30_1')}</span>{t('coupons_30_2')}
                                                </div>
                                            </div>
                                        )}
                                        {noticeBox && (
                                            <div style={{ position: "absolute", right: "0", bottom: "34px", width: "93%", background: "#fff", border: "1px solid #a5a5a5", padding: "20px", textAlign: "left", color: "#676767", zIndex: "2" }}>
                                                <X style={{ width: '22px', height: '22px', position: "absolute", right: "10px", top: '10px', color: "#9d9d9d", cursor: "pointer", zIndex: "3" }} onClick={() => setNoticeBox(false)} />
                                                <div style={{ fontSize: "13px", width: "100%", fontWeight: "bold", color: "#000" }}>{t('coupons_31')}</div>
                                                {
                                                    shoppingItem?.ci_available_store
                                                        ?
                                                        <>
                                                            <div style={{ fontSize: "11px", width: "100%", fontWeight: "500", marginTop: "10px", marginBottom: "2px" }}>{t('coupons_32')}</div>
                                                            <div style={{ fontSize: "11px", width: "100%", whiteSpace: 'pre-wrap' }}>{shoppingItem.ci_available_store}</div>
                                                        </>
                                                        :
                                                        ""
                                                }
                                                {
                                                    shoppingItem?.ci_unavailable_store
                                                        ?
                                                        <>
                                                            <div style={{ fontSize: "11px", width: "100%", fontWeight: "500", marginTop: "10px", marginBottom: "2px" }}>{t('coupons_33')}</div>
                                                            <div style={{ fontSize: "11px", width: "100%", whiteSpace: 'pre-wrap' }}>{shoppingItem.ci_unavailable_store}</div>
                                                        </>
                                                        :
                                                        ""
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        padding: "30px 15px",
                                        background: "#fff",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            lineHeight: '1.5',
                                            whiteSpace: 'pre-wrap',
                                            textAlign: 'left',
                                            color: "#000",
                                            wordBreak: "break-all"
                                        }}
                                    >
                                        {shoppingItem.ci_content}
                                    </div>
                                </div>
                            </>
                            :
                            <div
                                style={{
                                    padding: "15px",
                                    background: "#fff",
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        padding: "10px 0px 15px",
                                        color: "#000",
                                        textAlign: "left"
                                    }}
                                >
                                    {t('coupons_44')}
                                </div>
                                <div
                                    style={{
                                        fontSize: '14px',
                                        lineHeight: '1.5',
                                        whiteSpace: 'pre-wrap',
                                        textAlign: 'left',
                                        color: "#000",
                                        borderTop: "2px solid #e7e7e7",
                                        borderBottom: "1px solid #e7e7e7",
                                    }}
                                >
                                    <RowTable
                                        label={t('coupons_51')}
                                        value={"(주)케이티알파"}
                                    />
                                    <RowTable
                                        label={t('coupons_52')}
                                        value={shoppingItem.ci_affilate}
                                    />
                                    <RowTable
                                        label={t('coupons_53')}
                                        value={t('coupons_56')}
                                    />
                                    <RowTable
                                        label={t('coupons_54')}
                                        value={t('coupons_56')}
                                    />
                                    <RowTable
                                        label={t('coupons_55')}
                                        value={t('coupons_57')}
                                    />
                                </div>
                            </div>
                    }
                </div>
                <Coupons_Footer />
            </div>
        </div >
    );
}

function BuyModal({ setBuyModal, shoppingItem, setSpinner, setBuyState, buyState, setFriendModal, onSubmitBuy, onSubmitGift, setMessage }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const shoppingFriend = useSelector((state) => state.shoppingFriend.value);
    const shoppingLimit_KR = useSelector((state) => state.shoppingLimit_KR);
    const gold = useSelector((state) => { return state.gold.value })

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setTimeout(() => setVisible(true), 10);
    }, []);

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => { setBuyModal(false); setBuyState(0) }, 300); // 트랜지션 시간과 맞춰야 함
    };

    const handleBuyCoupons = (state) => {
        if (gold >= shoppingItem?.ci_point_price) {
            if (state === 1) {
                setSpinner(true)
                onSubmitBuy(shoppingItem.ci_goods_code, state)
            }
            else {
                setFriendModal(true)
            }
        }
        else {
            setMessage({ code: 1, msg: "포인트가 부족합니다." });
            dispatch(changeAlramModal());
        }
    };

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                handleClose();
            }
        };

        if (visible) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [visible]);

    return (
        <div
            ref={dropdownRef}
            style={{
                position: 'fixed',
                bottom: "0px",
                width: "100%",
                background: "#fff",
                zIndex: "20",
                borderTop: "2px solid #e1e1e1",
                padding: "10px",
                transition: "transform 0.3s ease-in-out",
                transform: visible ? "translateY(0)" : "translateY(100%)"
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: "-20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "45px",
                    height: "20px",
                    background: "#fff",
                    borderTop: "2px solid #e1e1e1",
                    borderRight: "2px solid #e1e1e1",
                    borderBottom: "0px",
                    borderLeft: "2px solid #e1e1e1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer"
                }}
                onClick={handleClose}
            >
                <FontAwesomeIcon icon={faSortDown} style={{ width: "9px", color: "#636262", paddingBottom: "7px" }} />
            </div>

            {
                buyState === 1 || buyState === 2
                    ?
                    <>
                        <div style={{ background: "#f5f5f5", border: "1px solid #ededed", borderRadius: "3px", padding: "10px", textAlign: "left" }}>
                            <div
                                style={{
                                    color: '#bfbfbf',
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    right: '15px',
                                    top: '15px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                onClick={handleClose}
                            >
                                <X style={{ width: '20px', height: '20px' }} />
                            </div>
                            <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "2px" }}>{shoppingItem.ci_goods_name}</div>
                            <div style={{ fontSize: "13px", fontWeight: "500", color: "gray", marginBottom: "15px" }}>{shoppingItem.ci_brand_name}</div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ fontSize: "12px", color: "gray" }}>{t('shopping_22')}</div>
                                <div style={{ fontSize: "13px", fontWeight: "bold" }}>{changeNum(shoppingItem.ci_point_price)}p</div>
                            </div>
                        </div>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 5px" }}>
                            <div style={{ color: "gray", fontSize: "13px", fontWeight: "bold" }}>{t('shopping_23')}</div>
                            <div style={{ fontSize: "15px", fontWeight: "800" }}>{changeNum(shoppingItem.ci_point_price)}p</div>
                        </div>
                        {
                            buyState === 1
                                ?
                                <div
                                    style={{
                                        width: "100%",
                                        background: "#ffbb3f",
                                        color: "#000",
                                        padding: "15px",
                                        fontSize: "14px",
                                        borderRadius: "5px",
                                        textAlign: "center",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleBuyCoupons(1)}
                                >
                                    {t('shopping_17')}
                                </div>
                                :
                                <div
                                    style={{
                                        width: "100%",
                                        background: "#000",
                                        color: "#fff",
                                        padding: "15px",
                                        fontSize: "14px",
                                        borderRadius: "5px",
                                        textAlign: "center",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleBuyCoupons(2)}
                                >
                                    {t('shopping_16')}
                                </div>
                        }
                    </>
                    :
                    <>
                        <div style={{ background: "#f5f5f5", border: "1px solid #ededed", borderRadius: "3px", padding: "10px", textAlign: "left", fontSize: '12px', marginBottom: "12px" }}>
                            <div
                                style={{
                                    color: '#bfbfbf',
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    right: '15px',
                                    top: '15px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                onClick={handleClose}
                            >
                                <X style={{ width: '20px', height: '20px' }} />
                            </div>
                            <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "8px" }}>{t('shopping_33')}</div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "5px" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Dot size={15} style={{ color: "#414141" }} />{t('shopping_34')}
                                </div>
                                <div style={{ fontWeight: "bold" }}>{shoppingLimit_KR?.todayUsage?.couponCount ?? 0}개 / {shoppingLimit_KR?.settings?.dailyCouponLimit ?? 0}개</div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Dot size={15} style={{ color: "#414141" }} />{t('shopping_35')}
                                </div>
                                <div style={{ fontWeight: "bold" }}>{changeNum(shoppingLimit_KR?.todayUsage?.pointUsed ?? 0)}p / {changeNum(shoppingLimit_KR?.settings?.dailyPointLimit ?? 0)}p</div>
                            </div>
                        </div>
                        <div
                            style={{
                                width: "100%",
                                background: "gray",
                                color: "#fff",
                                padding: "15px",
                                fontSize: "14px",
                                borderRadius: "5px",
                                textAlign: "center",
                                cursor: "pointer"
                            }}
                            onClick={() => handleClose()}
                        >
                            {t('shopping_36')}
                        </div>
                    </>
            }
        </div>
    );
}

function ShoppingFriendModal({ setFriendModal, shoppingItem, setSpinner, onSubmitGift }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const JWT = useSelector((state) => state.JWT.value);
    const mySkin = useSelector((state) => state.mySkin);
    const myData = useSelector((state) => state.myData);
    const shoppingFriend = useSelector((state) => state.shoppingFriend.value);

    const [friendList, setFriendList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [messageText, setMessageText] = useState("")
    const [messageModal, setMessageModal] = useState(false)
    const [selectedFriendData, setSelectedFriendData] = useState(null);

    // 검색어
    const [search, setSearch] = useState('');
    // 단일 선택 ID (내 user_id 또는 친구 friend_id)
    const [selectedUserId, setSelectedUserId] = useState(null);

    useEffect(() => {
        // 모달 애니메이션
        setTimeout(() => setVisible(true), 10);
        // 친구 목록 로드
        FriendData();
    }, []);

    // 친구 목록 받아오기
    const FriendData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/user/friend',
                {
                    headers: { Authorization: `Bearer ${JWT}` },
                }
            );
            if (response.data?.code === 1000) {
                setFriendList(response.data.data.friend ?? []);
            }
        } catch (error) {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.log(error);
            }
        }
    };

    useEffect(() => {
        if (!shoppingFriend) {
            setSelectedUserId(null);
            return;
        }

        if (shoppingFriend?.id && shoppingFriend.id === myData?.id) {
            setSelectedUserId(myData.id);
        }
        else if (shoppingFriend?.friend_id) {
            const found = friendList.find(
                (f) => f.friend_id === shoppingFriend.friend_id
            );
            setSelectedUserId(found ? found.friend_id : null);
        } else {
            setSelectedUserId(null);
        }
    }, [friendList, myData, shoppingFriend]);

    // 모달 닫기
    const handleClose = () => {
        setVisible(false);
        setTimeout(() => setFriendModal(false), 300);
    };

    const handleMessage = () => {
        console.log(selectedUserId, friendList)
        if (selectedUserId === myData?.id) {
            setSelectedFriendData({ ...myData });
        } else {
            const friend = friendList.find((item) => item.friend_id === selectedUserId);
            setSelectedFriendData(friend);
        }
        setMessageModal(true);
    };

    const handleComplete = () => {
        dispatch(changeShoppingFriend(""))
        setVisible(false);
        const friend = friendList.find((item) => item.friend_id === selectedUserId);

        setTimeout(() => {
            setFriendModal(false);
            setMessageModal(false)
            setSpinner(true);
            onSubmitGift(
                shoppingItem.ci_goods_code,
                2,
                friend,
                messageText
            );
        }, 300);
    };

    // 검색 필터
    const filteredFriendList = friendList.filter((item) =>
        item.user_name?.toLowerCase().includes(search.toLowerCase())
    );

    // 단일 선택 처리
    const handleSelect = (userId) => {
        setSelectedUserId((prev) => (prev === userId ? null : userId));
    };

    // 선택 원 스타일
    const circleStyle = (userId) => ({
        position: 'relative',
        width: '21px',
        height: '21px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border:
            selectedUserId === userId
                ? '1px solid #ffae19'
                : '1px solid #939393',
        background: selectedUserId === userId ? '#ffbb3f' : 'transparent',
    });

    // 체크 아이콘 스타일
    const checkIconStyle = {
        width: '14px',
        height: '14px',
        color: '#000',
    };

    const handleChange = (e) => {
        const value = e.target.value;
        // 최대 50자까지만 허용
        if (value.length <= 50) {
            setMessageText(value);
        }
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '0',
                width: '100%',
                height: '100%',
                background: '#fff',
                zIndex: '25',
                padding: '10px 20px 60px',
                transition: 'transform 0.3s ease-in-out',
                transform: visible ? 'translateY(0)' : 'translateY(100%)',
            }}
        >
            <div
                style={{
                    position: 'fixed',
                    top: '0px',
                    left: '0px',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '50px',
                    background: '#fff',
                    padding: '0 15px',
                    zIndex: '10',
                }}
            >
                {/* 닫기 아이콘 */}
                <div
                    style={{
                        color: '#000',
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                    onClick={handleClose}
                >
                    <X style={{ width: '26px', height: '26px' }} />
                </div>
                <div style={{ fontWeight: '500', color: '#000', fontSize: '16px' }}>
                    {t('shopping_10')}
                </div>
                {
                    selectedUserId && (
                        <div
                            style={{
                                position: 'absolute',
                                right: '15px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                                color: '#000',
                                fontWeight: "bold",
                                cursor: 'pointer',
                            }}
                            onClick={handleComplete}
                        >
                            {t('shopping_11')}
                        </div>
                    )
                }
            </div>
            {/* {
                messageModal && (
                    <FriendMessage handleComplete={handleComplete} messageText={messageText} handleChange={handleChange} selectedFriendData={selectedFriendData} shoppingItem={shoppingItem} setMessageModal={setMessageModal} />
                )
            } */}

            {/* 검색 영역 */}
            <div
                style={{
                    padding: '7px 10px',
                    background: '#f5f5f5',
                    marginTop: '40px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '10px',
                }}
            >
                <input
                    placeholder={t('shopping_12')}
                    style={{
                        border: 'none',
                        outline: 'none',
                        width: '100%',
                        background: '#f5f5f5',
                        fontSize: '14px',
                    }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            {/* 내 프로필 (행 전체 클릭) */}
            {/* <div
                style={{
                    textAlign: 'left',
                    borderBottom: '1px solid #f9f9f9',
                    marginBottom: '10px',
                }}
            >
                <div style={{ fontSize: '11px', color: 'gray' }}>{t('shopping_13')}</div>
                <div
                    onClick={() => handleSelect(myData?.id)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        margin: '15px 0',
                        cursor: 'pointer',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        <div
                            style={{
                                width: '45px',
                                height: '45px',
                                borderRadius: '40%',
                                background: '#f5f5f5',
                            }}
                        >
                            <img
                                src={`/img/noItem.png`}
                                style={{ width: '100%' }}
                                alt="my profile"
                            />
                        </div>
                        <div style={{ fontSize: '15px' }}>
                            {myData?.user_name ?? ''}
                        </div>
                    </div>
                    <div style={circleStyle(myData?.id)}>
                        {selectedUserId === myData?.id && (
                            <Check style={checkIconStyle} />
                        )}
                    </div>
                </div>
            </div> */}

            {/* 친구 목록 - 스크롤 */}
            <div
                style={{
                    maxHeight: 'calc(100% - 220px)',
                    overflow: 'auto',
                }}
            >
                {filteredFriendList?.length > 0 && (
                    <div style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: '11px', color: 'gray' }}>{t('shopping_14')}</div>
                        {filteredFriendList.map((item) => (
                            <div
                                key={item.friend_id}
                                onClick={() => handleSelect(item.friend_id)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    margin: '15px 0 0',
                                    cursor: 'pointer',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '45px',
                                            height: '45px',
                                            borderRadius: '40%',
                                            background: '#f5f5f5',
                                        }}
                                    >
                                        <img
                                            src={`${process.env.REACT_APP_API}${item.skin_img}`}
                                            style={{ width: '100%' }}
                                            alt={item.user_name}
                                        />
                                    </div>
                                    <div style={{ fontSize: '15px' }}>
                                        {item.user_name}
                                    </div>
                                </div>
                                <div style={circleStyle(item.friend_id)}>
                                    {selectedUserId === item.friend_id && (
                                        <Check style={checkIconStyle} />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

function FriendMessage({ handleComplete, messageText, handleChange, selectedFriendData, shoppingItem, setMessageModal }) {
    const { t } = useTranslation();
    const gold = useSelector((state) => { return state.gold.value })
    let navigate = useNavigate()

    return (
        <div style={{ position: "fixed", top: "0", left: "0", width: "100%", height: "calc(100dvh - 63px)", background: "#fff", zIndex: "100" }}>
            <div
                style={{
                    position: "absolute",
                    top: "0px",
                    left: "0px",
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: "50px",
                    background: "#fff",
                    padding: "0 15px",
                    zIndex: "10",
                    borderBottom: "1px solid #dddddd"
                }}
            >
                {/* 뒤로가기 버튼 */}
                <div
                    style={{
                        color: '#000',
                        cursor: 'pointer',
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    onClick={() => setMessageModal(false)}
                >
                    <ChevronLeft style={{ width: '30px', height: '30px' }} />
                </div>

                {/* 중앙 타이틀 */}

                <div className='table-overflow-1line' style={{ fontSize: "14px", width: "230px", fontWeight: "bold" }}><span style={{ fontSize: "15px" }}>To</span>. {selectedFriendData.user_name}</div>
                <div
                    style={{
                        color: '#000',
                        cursor: 'pointer',
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    onClick={() => {
                        window.scrollTo({ top: 0, left: 0 });
                        navigate('/shopping')
                    }}
                >
                    <X style={{ width: '28px', height: '28px' }} />
                </div>
            </div>
            <div style={{ marginTop: "50px", background: "#f5f5f5", paddingBottom: "8px", maxHeight: "calc(100% - 100px)", overflow: "scroll" }}>
                <div style={{ padding: "15px 10px 0", width: "100%", position: "relative", marginBottom: "8px", background: "#fff" }}>
                    <img src='/newImg/messageCard.png' style={{ width: "300px", borderRadius: "10px", margin: "0 auto" }} />
                    <div style={{ position: "absolute", top: "30px", left: "50%", transform: "translateX(-50%)", width: "280px" }}>
                        <textarea
                            className='textarea-placeholder'
                            value={messageText}
                            onChange={handleChange}
                            placeholder={`*${t('shopping_37')}`}
                            style={{
                                width: "100%",
                                height: "90px",
                                resize: "none",
                                padding: "7px",
                                boxSizing: "border-box",
                                fontSize: "16px",
                                lineHeight: "1.5",
                                overflowWrap: "break-word",
                                whiteSpace: "pre-wrap",
                                border: "1px solid #ff9ba8",
                                borderRadius: "3px",
                                fontFamily: "inherit",
                                background: "#fc8796",
                                color: "#fff",
                                textAlign: "center"
                            }}
                        />
                        <div
                            style={{
                                position: "absolute",
                                bottom: "-20px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                fontSize: "13px",
                                color: "#fff",
                            }}
                        >
                            {messageText.length} / 50
                        </div>
                    </div>
                </div>

                <div style={{ padding: "15px", background: "#fff", marginBottom: "8px" }}>
                    <div style={{ textAlign: "left", fontSize: "15px", fontWeight: "bold", color: "#000", marginBottom: "5px" }}>{t('shopping_38')}</div>
                    <div style={{ padding: "10px", display: "flex", gap: "10px", border: "2px solid #f5f5f5", borderRadius: "10px" }}>
                        <div
                            style={{
                                width: "90px",
                                height: "90px",
                                overflow: "hidden",
                                borderRadius: "4px",
                                border: "1px solid #f9f9f9"
                            }}
                        >
                            <FallbackImage
                                src={shoppingItem?.ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${shoppingItem.ci_custom_image_filename}` : shoppingItem.ci_goods_img_big}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </div>

                        <div style={{ width: "calc(100% - 75px)", textAlign: "left", display: "flex", justifyContent: "center", flexDirection: "column" }}>
                            <div style={{ fontSize: "12px", color: "#a9a9a9", fontWeight: "500" }}>
                                {shoppingItem.ci_brand_name}
                            </div>

                            <div className='table-overflow-2lines' style={{ fontSize: "13px", color: "#5f5f5f", fontWeight: "bold", marginBottom: "5px" }}>
                                {shoppingItem.ci_goods_name}
                            </div>

                            <div style={{ fontSize: "14px", marginBottom: "2px", fontWeight: "bold" }}>
                                {changeNum(shoppingItem.ci_point_price)}p
                            </div>

                            <div style={{ fontSize: "12px", color: "#a9a9a9", fontWeight: "500" }}>
                                {t('shopping_22')}
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ background: "#fff", marginBottom: "8px" }}>
                    <div style={{ padding: "15px", textAlign: "left", fontSize: "15px", fontWeight: "bold", color: "#000", borderBottom: "2px solid #f5f5f5" }}>{t('shopping_39')}</div>
                    <div style={{ padding: "15px", textAlign: "left", color: "#000" }}>
                        <div style={{ padding: "0 0 15px", textAlign: "left", fontSize: "13px", borderBottom: "1px solid #f5f5f5", fontWeight: "500" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                                <div>{t('shopping_40')}</div>
                                <div>{changeNum(gold)}p</div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div>{t('shopping_41')}</div>
                                <div>{changeNum(shoppingItem.ci_point_price)}p</div>
                            </div>
                        </div>
                        <div style={{ padding: "12px 0 0", textAlign: "left", fontSize: "14px", fontWeight: "bold" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div>{t('shopping_42')}</div>
                                <div style={{ fontSize: "16px" }}>{changeNum(gold - shoppingItem.ci_point_price)}p</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ padding: "15px", background: "#fff" }}>
                    <div style={{ textAlign: "left", fontSize: "12px", fontWeight: "500", color: "gray" }}><span style={{ fontWeight: "bold", textDecoration: "underline" }}>{t('shopping_43')}</span> {t('shopping_44')}</div>
                </div>
            </div>
            <div style={{
                position: "absolute", bottom: "0", left: "0",
                width: "100%", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", background: "#ffbb3f", color: "#000", marginTop: "10px", cursor: "pointer", fontWeight: "bold"
            }} onClick={handleComplete}>{t('shopping_17')}
            </div>
        </div>
    )
}

const RowTable = ({ label, value }) => (
    <div
        style={{
            display: 'flex',
            fontSize: '14px',
            fontWeight: "500",
            borderBottom: '1px solid #e7e7e7',
        }}
    >
        <div style={{ color: '#616161', width: "120px", background: "#ededed", padding: "10px" }}>{label}</div>
        <div style={{ color: '#000', flex: 1, whiteSpace: 'pre-wrap', padding: "10px", width: "calc(100% - 120px)" }}>{value}</div>
    </div>
);

export default ShoppingDetail;